/*
====================================================================
      Función confirmarCambioContraseña
====================================================================
Esta función envía una solicitud al backend para confirmar el cambio 
de contraseña utilizando un token de restablecimiento y la nueva 
contraseña del usuario. La solicitud se realiza a la API del servidor 
para completar el proceso de cambio de contraseña.

====================================================================
*/

// ------------------------------------------------------------------
//                            IMPORTS
// ------------------------------------------------------------------
// Importación de la configuración necesaria.

import { V_URL_API } from '../../../utils/config';
import CambiarContraseñaEntity from '../../../core/entities/cambiarContraseñaEntity';


// ------------------------------------------------------------------
//                   DEFINICIÓN DE LA FUNCIÓN
// ------------------------------------------------------------------
/**
 * Envía la nueva contraseña junto con el token temporal al backend para confirmar el cambio de contraseña.
 *
 * @param {string} token - El token temporal proporcionado para el cambio de contraseña.
 * @param {CambiarContraseñaEntity} CambiarContraseñaEntity - 
 *        Una instancia de la entidad CambiarContraseñaEntity que contiene la 
 *        nueva contraseña y su confirmación.
 * @returns {Promise<Response>} - Una promesa que resuelve con la respuesta del servidor.
 */
export async function cambiarContraseñaTemporal(token, CambiarContraseñaEntity = new CambiarContraseñaEntity()) {
  const myHeaders = new Headers();
  myHeaders.append("Authorization", `E ${token}`);
  myHeaders.append("Content-Type", "application/json");

  const raw = JSON.stringify(CambiarContraseñaEntity);

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  return fetch(`${V_URL_API}/api/cambiar_contraseña/temporal`, requestOptions);
}
/*
====================================================================
      Función verificarToken
====================================================================
Esta función verifica la validez de un token de restablecimiento de 
contraseña enviado al backend. El propósito de esta función es 
asegurarse de que el token proporcionado sigue siendo válido antes de 
continuar con el proceso de restablecimiento de contraseña.

====================================================================
*/
